import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import convertCurrency from "src/helper/convertCurrency";

export default function NumericTextfield({ label, onChange, value, ...props }) {
  return (
    <Box>
      <NumericFormat
        {...props}
        fullWidth
        label={label}
        InputProps={{
          inputProps: { min: 0 },
          startAdornment: (
            <InputAdornment position="start">
              <Typography>đ{value ? "" : 0}</Typography>
            </InputAdornment>
          ),
        }}
        thousandSeparator
        customInput={TextField}
        onValueChange={(values) => onChange(values)}
      />
      <Typography
        variant="body2"
        sx={{ fontWeight: "bold", fontStyle: "italic" }}
      >
        ({!!value ? convertCurrency(value) : 0} đồng)
      </Typography>
    </Box>
  );
}
